import CardWrapper from '../wrapper/card';
import { ComposeSMSParams } from '../../params/redux/sms';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { settingSelectedSMS } from '../../redux/slices/sms';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Divider, Typography } from '@mui/material';
import { brand, gray } from '../../theme/themePrimitives';
import { composeSMSThunk, fetchSMSMessagesThunk } from '../../redux/thunks/sms';
import { emailAndPhoneOptions, formatDateWithTime } from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

const SMSThreadComponent = () => {
    const [message, setMessage] = useState<string>('');
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch<AppDispatch>();
    const messagesEndRef = useRef<HTMLDivElement | null>(null);
    const { selectedSms, smsThread, loaders } = useSelector((state: RootState) => state.sms);

     useEffect(() => {
            if (messagesEndRef.current) {
                messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        });

    const backNavigationHandler = () => {
        dispatch(settingSelectedSMS(null));
    };

    useEffect(() => {
        const fetchSMS = async () => {
            try {
                await dispatch(fetchSMSMessagesThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            } catch (e) {
                //
            }
        };
        fetchSMS();
        const interval = setInterval(() => {
            fetchSMS();
        }, 10000);
        return () => {
            clearInterval(interval);
        };
    }, [dispatch, id]);

    const replyToThreadHandler = async () => {
        try {
            const data: ComposeSMSParams = {
                to: selectedSms?.message_to,
                message,
                message_id: selectedSms?.id,
                client_id: id ? parseInt(id as string, 10) : 0
            };
            await dispatch(composeSMSThunk(data)).unwrap();
            setMessage('');
        } catch (e) {
            //
        }
    };

    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Button startIcon={<KeyboardArrowLeftRounded />} variant="text" color="secondary" disabled={loaders.isCreating || loaders.isLoading} onClick={backNavigationHandler}>Back</Button>
                <Typography variant="h6" color="textSecondary">{selectedSms?.message_to}</Typography>
                <Box></Box>
            </Box>
            <CardWrapper>
                <Box minHeight="55vh" maxHeight="55vh" px={1} overflow="auto" display="flex" flexDirection="column" gap={2} >
                    {
                        smsThread.map((mes) => <Box display="flex" alignItems="center" justifyContent={mes.is_sent === 1 ? 'end' : 'start'} key={mes.id} width="100%">
                            <Box width="max-content">
                                <Box
                                    bgcolor={mes.is_sent === 1 ? brand[300] : gray[300]} px={2} py={1} sx={{
                                        borderTopLeftRadius: mes.is_sent === 1 ? '10px' : '0',
                                        borderTopRightRadius: mes.is_sent === 1 ? '0' : '10px',
                                        borderBottomRightRadius: '10px',
                                        borderBottomLeftRadius: '10px'
                                    }}
                                    color={mes.is_sent === 1 ? 'white' : 'black'}
                                >
                                    <Typography variant="subtitle1">{mes.message}</Typography>
                                </Box>
                                <Typography variant="body1" color="textDisabled">{formatDateWithTime(mes.created_at)}</Typography>
                            </Box>
                        </Box>)
                    }
                    <div ref={messagesEndRef} />
                </Box>
                <Divider />
                <Box display="flex" mt={1} gap={2}>
                    <Box width="100%">
                        <CustomInput
                            type="textarea"
                            row={8}
                            placeholder="Type Here..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            disabled={loaders.isCreating || loaders.isLoading}
                            fullWidth
                        />
                    </Box>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Box>
                            <CustomDropdown
                                options={emailAndPhoneOptions}
                                value=""
                                placeholder="Add Field"
                                disabled={loaders.isCreating}
                                onChange={(e) => setMessage(`${message} [${e.target.value}]`)}
                                sx={{
                                    marginBottom: 0
                                }}
                            />
                        </Box>
                        <Button variant="contained" size="large" fullWidth onClick={replyToThreadHandler} disabled={message.trim() === '' || loaders.isCreating || loaders.isLoading}>Send</Button>
                    </Box>
                </Box>
            </CardWrapper>
        </Box>
    );
};

export default SMSThreadComponent;